import deck from "./cards.js";
import arrayShuffle from "array-shuffle";
export default arrayShuffle(deck);
